import { translateOrderTypeItemName } from "../../common/enums/orderTypes.enum";

export const pricesColumns = (t: any) => [
    {
      key: "name",
      name: t("pricing.columns.name"),
      fieldName: "name",
      minWidth: 300,
      maxWidth: 600,
      isResizable: true,
      onRender: (item: any) => translateOrderTypeItemName(item.name, t),
    },
    {
      key: "priceValue",
      name: t("pricing.columns.priceValue"),
      fieldName: "priceValue",
      minWidth:100,
      maxWidth: 200,
      isResizable: true,
    },
];